import React, { Component } from "react";
import { cloneDeep as _cloneDeep, get as _get, isEmpty as _isEmpty, isEqual as _isEqual } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { withCookies, Cookies } from "react-cookie";
import { NavLink } from "react-router-dom";
import { instanceOf } from "prop-types";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { IconEye, IconPassword } from "../../helpers/iconStyles";
import { encryptData, decryptData } from "../../helpers/crypto";
import { isValidEmail } from "../../helpers/utils";
import config from "../../helpers/config";

import { doLogin, clearOauthError, clearOauthSuccess } from "../../actions/oauth";

class Login extends Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  constructor(props) {
    super(props);

    const { cookies } = props;

    const tokenData = decryptData(cookies.get("LgnData"));

    this.defaultCredentials = {
      email: _get(tokenData, "email", ""),
      password: _get(tokenData, "key", ""),
      remember: _get(tokenData, "rm", false)
    };

    this.state = {
      credentials: _cloneDeep(this.defaultCredentials),
      errors: {},
      successAlert: {},
      errorAlert: {},
      disabled: true,
      showPassword: false,
      isSubmitClicked: false
    };
  }

  componentDidMount() {
    const { success, error, clearOauthError } = this.props;

    window.scrollTo({ top: 0, behavior: "smooth" });

    if (!_isEmpty(success)) {
      this.setState({
        successAlert: {
          title: (success.title || "Success"),
          message: (success.message || "Login successfully!"),
        },
      });

      if (typeof this.props.clearOauthSuccess === "function") { this.props.clearOauthSuccess(); }
    }

    if (!_isEmpty(error)) {
      this.setState({
        errorAlert: {
          title: (error.title || "Alert"),
          message: (error.message || "Something went wrong while login!")
        }
      });

      if (typeof clearOauthError === "function") { clearOauthError(); }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_isEqual(prevState.credentials, this.state.credentials) && _get(this.state, "isSubmitClicked", false) === true) { this._handleValidation(); }

    if (!_isEqual(prevProps.error, this.props.error) && !_isEmpty(this.props.error)) {
      this.setState({
        errorAlert: {
          title: _get(this.props, "error.title", "Alert"),
          message: _get(this.props, "error.message", ""),
        },
      });

      if (typeof this.props.clearOauthError === "function") { this.props.clearOauthError(); }
    }

    if (!_isEqual(prevProps.token, this.props.token) && !_isEmpty(this.props.token)) {
      const { cookies, token } = this.props;

      const tokenCookie = encryptData({ "token": token });
      cookies.set("tknData", tokenCookie, { path: "/", domain: `.${process.env.REACT_APP_FRONTEND_DOMAIN}` });
    }
  }

  _handleChange = (e) => {
    e.preventDefault();

    const { name, value } = (e.target || {});

    this.setState((prevState) => ({
      credentials: {
        ...prevState.credentials,
        [name]: value
      },
      errorAlert: {},
      successAlert: {}
    }));
  }

  _handleValidation = () => {
    const { intl } = this.props;
    const { credentials: { email, password } } = this.state;
    let errors = {};

    if (!isValidEmail(email)) {
      errors["email"] = intl.formatMessage({ id: "error.invalid", defaultMessage: "Invalid {field}" }, {
        field: intl.formatMessage({ id: "email", defaultMessage: "email" }),
      });
    }

    if (_isEmpty(password)) {
      errors["password"] = intl.formatMessage({ id: "error.required", defaultMessage: "{field} is required" }, {
        field: intl.formatMessage({ id: "password", defaultMessage: "password" }),
      });
    }

    this.setState({
      errorAlert: {},
      successAlert: {},
      disabled: !_isEmpty(errors),
      errors
    });
  }

  _doLogin = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { doLogin, cookies } = this.props;
    const { credentials: { email, password, remember }, errors } = this.state;

    if (!isValidEmail(email) || _isEmpty(password) || !_isEmpty(errors)) {
      this.setState({ isSubmitClicked: true }, () => {
        this._handleValidation();
      });

      return;
    }

    if (typeof doLogin === "function") { doLogin({ user_name: email, password: password }); }

    const cookieData = encryptData({ "email": (email || ""), "key": (password || ""), "rm": (remember || false) });

    if (remember === true) {
      cookies.set("LgnData", cookieData, { path: "/", domain: `.${process.env.REACT_APP_FRONTEND_DOMAIN}` });
    } else {
      cookies.remove("LgnData", { path: "/", domain: `.${process.env.REACT_APP_FRONTEND_DOMAIN}` });
    }
  }

  render() {
    const { token, intl } = this.props;
    const { errors, errorAlert, showPassword } = this.state;

    if (!_isEmpty(token)) {
      // const search = _get(window, "location.search", "");
      // const params = new URLSearchParams(search);
      // const url = (params.get("continue") || "/");

      window.location = config.getAdminURL(true, true, "/enrich/contact");
      return null;
    }

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "enrich.login", defaultMessage: "Login: Enrich B2B" })}
          </title>
        </Helmet>
        <div className="section-login login-form outer-pattern">
          <div className="container container-1120">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="heading-01 fw-medium text-center mb-lg-9 mb-4">
                  <FormattedMessage id="login.title" defaultMessage="Login" />
                </h1>
                <p className="heading-06 text-grey-63 text-center mb-lg-15 mb-8">
                  <FormattedMessage id="login.subtitle" defaultMessage="Welcome back, please login to your account." />
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 mx-auto">

                <Form autoComplete="off" onSubmit={(e) => this._doLogin(e)}>

                  {!_isEmpty(errorAlert) && (
                    <div className="mb-3 text-danger text-capitalize-first">
                      <span>{(errorAlert.message || "")}</span>
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="fw-semibold mb-2"><FormattedMessage id="login.form.email" defaultMessage="Email :" /></label>
                    <input type="email" name="email" className="form-control form-control-lg" placeholder="Email" onChange={(e) => this._handleChange(e)} />
                    {(errors.email || "") && (
                      <p className="small fw-bold text-danger mt-1 ps-26 text-capitalize-first"> {errors.email} </p>
                    )}
                  </div>

                  <div className="mb-3 position-relative">
                    <span className="cursor-pointer" onClick={() => this.setState({ showPassword: !showPassword })}>

                      {(showPassword === false) && (
                        <IconPassword size="16px" />
                      )}
                      {(showPassword === true) && (
                        <span className="position-absolute icon-password end-0 top-50 translate-middle-y me-2 cursor-pointer">
                          <IconEye width="16px" height="16px" color="#636E72" />
                        </span>
                      )}
                    </span>
                    <label className="fw-semibold mb-2"><FormattedMessage id="login.form.password" defaultMessage="Password :" /></label>
                    <input
                      type={(showPassword === true) ? "text" : "password"}
                      name="password"
                      className="form-control form-control-lg"
                      placeholder="Password"
                      onChange={(e) => this._handleChange(e)}
                    />
                    {(errors.password || "") && (
                      <p className="small fw-bold text-danger mt-1 ps-26 text-capitalize-first"> {errors.password} </p>
                    )}
                  </div>

                  <div className="mb-8">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="flexCheckDefault"
                          onClick={(e) =>
                            this.setState((prevState) => ({
                              credentials: {
                                ...prevState.credentials,
                                remember: !_get(prevState, "credentials.remember", false)
                              },
                            }))
                          } />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                          <FormattedMessage id="login.remember_me" defaultMessage="Remember me" />
                        </label>
                      </div>

                      <NavLink to="/forgot-password" className="link-grey-63 fw-medium text-capitalize">
                        <FormattedMessage id="login.forgot_link" defaultMessage="forgot password?" />
                      </NavLink>
                    </div>
                  </div>

                  <div className="mb-2">
                    <button type="submit" className="btn btn-lg btn-primary w-100 text-capitalize">
                      <FormattedMessage id="btn.sign_in" defaultMessage="sign in" />
                    </button>
                  </div>

                  <div className="mb-2">
                    <p className="text-grey-63 fw-bold">
                      <FormattedMessage id="login.dont_have_account" defaultMessage="Don’t you have an account? " />
                      <NavLink to="/sign-up" className="link-primary">
                        <FormattedMessage id="login.sign_up_link" defaultMessage=" Create an account" />
                      </NavLink>
                    </p>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  error: _get(state, "oauth.error", {}),
  token: _get(state, "oauth.token", null),
  success: _get(state, "oauth.success", {}),
});

const mapDispatchToProps = (dispatch) => ({
  doLogin: (data) => dispatch(doLogin(data)),
  clearOauthError: () => dispatch(clearOauthError()),
  clearOauthSuccess: () => dispatch(clearOauthSuccess()),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withCookies(Login)));
